import { ReactNode } from "react";

// TODO i should create a dependancy between Data and Column
export interface Column {
  id: string;
  label?: string | ReactNode;
  filter?: FilterColumn;
  minWidth?: number;
  maxWidth?: number;
  width?: number;
  style?: string; // TODO this will need to be change
  rowStyle?: string; // TODO this will need to be change
  align?: "right";
  format?: (value: number) => string; // SEE is it necessary ?
  bulle?: string; //

  cell: IRenderCell;
}

// TODO make dependable type
export interface FilterColumn {
  type?: DataTableFilterType;
  // value: any;
  styleFilter?: any;
  options?: any;
  label?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  multiple?: boolean;
  valueFilter?: (...args: any) => any;
  testid?: string;
}

// TODO make dependable type
interface IRenderCell {
  type?: DataTableRowType;
  value: (...args: any) =>
    | string
    | ReactNode
    | {
        title: string;
        subtitle: string;
        isLarge?: boolean;
        noEllipsis?: boolean;
      };
  link?: (...args: any) => string;
  onClick?: any; // (...args: any) => void;
  isDisabled?: boolean | ((...args: any) => any);
  badge?: BadgeType;
}

export interface DataTableProps {
  queryFunction: (params: any) => any;
  rowsPerPage?: number;
  thead: Column[];
  className?: string;
  usePaper?: boolean;
  queryFunctionName: string;
  withThead?: boolean;
  CollapsedChildren?: any;
}

interface Data {
  value: string;
  isDisable?: boolean;
  customCellClass?: string;
  containsChevron?: boolean;
  components?: ReactNode;
  color?: string;
  type?: string;
  link?: string;
  onClickAction?: any; // TODO fix this
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

// TODO i need to type everything correctly to make the composition later
export interface TBodyProps<T extends Data> {
  data: T;
  thead: Column[];
  isRowRelative: boolean;
  noPointer: boolean;
  noHover: boolean;
  CollapsedChildren?: any;
  queryFunctionName: string;
}

export const EnumDataRowType = {
  Link: "link",
  Dropdown: "dropdown",
  Badge: "badge",
  EmptyLink: "EmptyLink",
} as const;

export type DataTableRowType =
  (typeof EnumDataRowType)[keyof typeof EnumDataRowType];

export const EnumBadgeType = {
  Project: "project",
  Edb: "edb",
} as const;

export type BadgeType = (typeof EnumBadgeType)[keyof typeof EnumBadgeType];

export interface RenderCellProps extends IRenderCell {
  row: any;
}

export const EnumFilterTypes = {
  INPUT: "input",
  INPUT_NUMBER: "inputNumber",
  AUTOCOMPLETE: "autocomplete",
  SELECT: "select",
  DATE: "date",
  BUTTON: "button",
} as const;

export type DataTableFilterType =
  (typeof EnumFilterTypes)[keyof typeof EnumFilterTypes];
